const products = [
  {
    path: 'categories',
    name: 'categories',
    icon: 'cil-spreadsheet',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'products'
    },
    children: [
      {
        path: '',
        name: 'categories_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/category/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: 'new',
        name: 'category_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/category/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: ':id',
        name: 'category',
        components: {
          content: () => import('@/views/pages/category/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: ':id/products',
        name: 'product_category',
        components: {
          content: () => import('@/views/pages/product/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      }
    ]
  },

  {
    path: 'orders',
    name: 'orders',
    icon: 'cil-list-high-priority',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'products'
    },
    children: [
      {
        path: '',
        name: 'orders_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/orders/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: 'new',
        name: 'orders_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/orders/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: ':id',
        name: 'orders_view',
        components: {
          content: () => import('@/views/pages/orders/View.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      }
    ]
  },

  {
    path: 'products',
    name: 'products',
    icon: 'cib-product-hunt',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'products'
    },
    children: [
      {
        path: '',
        name: 'products_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/product/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: ':id',
        name: 'product',
        components: {
          content: () => import('@/views/pages/product/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: ':id/with-variants',
        name: 'product_variants',
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          variants: true,
          moduleSlug: 'products'
        },
        components: {
          content: () => import('@/views/pages/product/Edit.vue')
        }
      },

      {
        path: 'new',
        name: 'product_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/product/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          requiredPermission: 'adminCanAddProduct',
          moduleSlug: 'products'
        }
      },

      {
        path: 'new/with-variants',
        name: 'product_new_variants',
        showInMenu: true,
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          requiredPermission: 'adminCanAddProduct',
          moduleSlug: 'products'
        },
        components: {
          content: () => import('@/views/pages/product/New.vue')
        }
      }
    ]
  },

  {
    path: 'vendors',
    name: 'vendors',
    icon: 'cil-factory',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'vendors'
    },
    children: [
      {
        path: '',
        name: 'vendors_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/vendor/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'vendors'
        }
      },
      {
        path: ':id',
        name: 'vendor_edit',
        components: {
          content: () => import('@/views/pages/vendor/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'vendors'
        }
      },

      {
        path: 'new',
        name: 'vendor_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/vendor/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'vendors'
        }
      }
    ]
  },

  {
    path: 'suppliers',
    name: 'suppliers',
    icon: 'cib-brand-ai',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'products'
    },
    children: [
      {
        path: '',
        name: 'suppliers_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/suppliers/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },
      {
        path: ':id',
        name: 'supplier_edit',
        components: {
          content: () => import('@/views/pages/suppliers/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      },

      {
        path: 'new',
        name: 'supplier_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/suppliers/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'products'
        }
      }
    ]
  },

  {
    path: 'featured',
    name: 'featured',
    icon: 'cil-star',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/featured_products/Index.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'products'
    }
  },
  {
    path: 'imported',
    name: 'imported_products',
    icon: 'cil-star',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/import/Index.vue')
    },
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'products'
    }
  },

  {
    path: 'ipcs',
    name: 'ipcs_list',
    icon: 'cil-list',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/ipc/List.vue')
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'products'
    }
  },

  {
    path: 'vouchers',
    name: 'vouchers',
    icon: 'cil-spreadsheet',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'vouchers'
    },
    children: [
      {
        path: '',
        name: 'vouchers_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/vouchers/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'vouchers'
        }
      },
      {
        path: 'new',
        name: 'vouchers_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/vouchers/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'vouchers'
        }
      }
    ]
  }
]

export default products
